<template>
  <div
    v-if="isToast"
    :class="`c-toast z-[10000] c-toast--${close ? 'close' : 'default'} c-toast--${
      icon.length > 0 ? `${icon}` : 'default'
    } fixed bottom-[20px] left-[20px] ${isMobile ? 'mo' : ''}`"
    :style="{ width: computedWidth }"
  >
    <i
      v-if="icon.length > 0"
      :class="`c-toast__icon`"
    >
      <span class="s-hide">toast icon</span>
    </i>
    <span class="c-toast__txt">
      <slot>
        {{ desc }}
      </slot>
    </span>
    <button
      v-if="close"
      type="button"
      class="c-toast__close"
      @click="() => onClose()"
    >
      <i class="c-icon c-icon--close" />
      <span class="s-hide">close</span>
    </button>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
  isToast: {
    type: Boolean,
    default: false,
  },
  close: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  width: {
    type: String,
    default: '',
  },
  desc: {
    type: String,
    default: '',
  },
  onClose: {
    type: Function,
    default: () => {},
  },
});

// default width
const computedWidth = computed(() => {
  return props.width == '' && isMobile ? '32rem' : '47rem';
})

// check device
const isMobile = ref(true);

const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 767;
}

onMounted(() => {
  checkIsMobile();
  window.addEventListener('resize', checkIsMobile);
});
</script>

<style lang="scss" scoped>
.c-toast {
  $this: '.c-toast';
  border: 1px solid var(--main-40);
  color: var(--main-10);
  padding: 2rem 2.4rem;
  border-radius: 0.4rem;
  font-size: var(--font-16);
  font-weight: var(--font-medium);
  display: flex;
  align-items: center;
  background-color: var(--white);
  &--error {
    border-color: var(--state-10);
    #{$this}__icon {
      background: url(@/assets/images/icon_event_error.svg) center / contain no-repeat;
    }
  }
  &__txt {
    max-width: 35.4rem;
  }
  &__icon {
    width: 2rem;
    height: 2rem;
    margin-right: 1.2rem;
    background: url(@/assets/images/icon_event_check.svg) center / contain no-repeat;
  }
  &__close {
    width: 1.2rem;
    height: 1.2rem;
    margin-left: 2.4rem;
    .c-icon {
      width: 100%;
      height: 100%;
    }
  }
}

.c-toast.mo {
  padding: 1.5rem 1.2rem;
}
</style>
